/**
 * 营销渠道 echarts图表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>-->

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">

      <el-form-item label="搜索：">
        <el-date-picker
          size="small"
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>


    <!--图表-->
    <div class="onlyCss">

      <el-table
        :data="list"
        :span-method="objectSpanMethod"
        border
        max-height="calc(100vh - 260px)"
        style="width: 100%; min-height: 100%">
        <el-table-column
          prop="parentName"
          label="培训科目">
        </el-table-column>
        <el-table-column
          prop="twoName"
          label="作业类别">
        </el-table-column>
        <el-table-column
          prop="threeName"
          label="操作项目">
        </el-table-column>
        <el-table-column
          prop="studentNum"
          label="报名人数">
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import { querySubjectReport } from '../../api/report'
import { timestampToTime } from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  props: {
    type: String
  },
  data() {
    return {
      myChart: '',
      dateValue: [],
      loading: false, //是显示加载
      queryParams: {
        startTime: '',
        endTime: '',
        // reportType: this.type      SUBJECT,AREA,AGE,MARKETING_CHANNEL
      },
      list: [],

      tableOneArr: [],
      tableOnePos: 0,
      tableTwoArr: [],
      tableTwoPos: 0,

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */

  created() {

    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    changeData() {
      this.tableOneArr = [];
      this.tableOnePos = 0;
      this.tableTwoArr = [];
      this.tableTwoPos = 0;

      for (var i = 0; i < this.list.length; i++) {
        if (i === 0) {
          // 第一行必须存在
          this.tableOneArr.push(1);
          this.tableOnePos = 0;
          this.tableTwoArr.push(1);
          this.tableTwoPos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (this.list[i].parentName === this.list[i - 1].parentName) {
            this.tableOneArr[this.tableOnePos] += 1;
            this.tableOneArr.push(0);
          } else {
            this.tableOneArr.push(1);
            this.tableOnePos = i;
          }
          //判断当前元素是否与上一元素相同且为空
          if (this.list[i].twoName === this.list[i - 1].twoName) {
            this.tableTwoArr[this.tableTwoPos] += 1;
            this.tableTwoArr.push(0);
          } else {
            this.tableTwoArr.push(1);
            this.tableTwoPos = i;
          }
        }
      }

      // 表格序号
      let numSort = 0
      for (const n in this.tableOneArr) {
        if (this.tableOneArr[n] > 0) {
          numSort += 1
          this.list[n].numSort = numSort
        }
      }

    },

    initData() {
      const currentDate = new Date();
      // this.queryParams.startTime = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
      // this.queryParams.endTime = this.formatDate(currentDate)
      this.dateValue.push(this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)));
      this.dateValue.push(this.formatDate(currentDate));
      this.getdata()
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取角色列表
    getdata() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      querySubjectReport(JSON.stringify(this.queryParams)).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.list = res.data;
          this.changeData()
        }
      })
      .catch(err => {
        this.$message.error('加载失败，请稍后再试！')
      })
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {

      if (columnIndex === 0) {
        // 第一列的合并方法,省
        const _row = this.tableOneArr[rowIndex]
        const _col = _row > 0 ? 1 : 0 // 如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row,
          colspan: _col
        }
      } else if (columnIndex === 1){
        const _row = this.tableTwoArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }

    },

    // 搜索事件
    search() {
      const currentDate = new Date();
      this.queryParams.startTime = this.dateValue.length > 0 ? timestampToTime(this.dateValue[0]).split(' ')[0] : this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
      this.queryParams.endTime = this.dateValue.length > 0 ? timestampToTime(this.dateValue[1]).split(' ')[0] : this.formatDate(currentDate);
      this.getdata()
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.onlyCss {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98.5%;
  height: 70vh;
  background-color: #f6f6f6;
  border-right: 8px !important;
  margin: 10px;
}
.twoCss {
  width: 80%;
  height: 80%;
}

/deep/ .el-table {
  display: flex;
  flex-direction: column;
}

/deep/ .el-table__header-wrapper {
  overflow: unset !important;
}

</style>




// WEBPACK FOOTER //
// src/views/report/subjectReport.vue